import { func, object } from 'prop-types';
import React from 'react';
import { path } from 'ramda';

import ActionButton from 'components/ActionButton';
import ContentColumns from '../components/ContentColumns';

import View1 from './Views/View1';
import View2 from './Views/View2';
import View3 from './Views/View3';
import View4 from './Views/View4';
class Rehabilitation7 extends React.Component {
  state = {
    view: 1,
  };

  componentDidMount() {
    const finished = path(['formValues', 'rehab7', 'finished'], this.context);
    // If this session is finished, navigate to last view
    if (finished) this.setState({ view: 4 });
  }

  advanceView = () => {
    const { setFinished } = this.context;
    if (this.state.view === 3) {
      setFinished();
    }
    this.setState({ view: this.state.view + 1 });
  };

  backView = () => {
    this.setState({ view: this.state.view - 1 });
  };

  render() {
    const { view } = this.state;
    return (
      <div>
        {view === 1 ? <View1 advanceView={this.advanceView} /> : null}
        {view === 2 ? <View2 advanceView={this.advanceView} /> : null}
        {view === 3 ? <View3 advanceView={this.advanceView} /> : null}
        {view === 4 ? <View4 advanceView={this.advanceView} /> : null}
        <ContentColumns
          firstColumn={
            <div style={{ display: 'flex', marginTop: '2rem' }}>
              <div style={{ flex: 1 }}>
                {view > 1 ? (
                  <ActionButton
                    localeId={'onlineRehabilitation.back'}
                    onClick={this.backView}
                    style={{ width: '15rem' }}
                    secondary
                  />
                ) : null}
              </div>
              {view !== 4 && (
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                  <ActionButton
                    localeId={view === 8 ? 'onlineRehabilitation.send' : 'onlineRehabilitation.advance'}
                    onClick={this.advanceView}
                    style={{ width: '15rem' }}
                    filledSecondary
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

Rehabilitation7.contextTypes = { setFinished: func, formValues: object };
Rehabilitation7.propTypes = {};

export default Rehabilitation7;
